import { SET_CURRENT_AND_PREVIOUS_ROUTE } from "./types";
import { createAction } from "@reduxjs/toolkit";
import { SetCurrentandPreviousRoute } from "./types";

export const setCurrentAndPreviousRoute = createAction<SetCurrentandPreviousRoute["payload"]>(
    SET_CURRENT_AND_PREVIOUS_ROUTE
);
